<template>
  <form class="col-md-6 col-lg-6">
    <div class="form-group">
      <label class="form__label" for="sort">
        <font-awesome-icon :icon="['fas', 'sort-amount-up']" class="mr-lg-2 mr-md-2 mr-2 icon"/>
        SORT BY
      </label>
      <select v-if="pKinds" v-model="sortMethod" @change="sortKind" aria-describedby="sortResults"
              class="form-select mb-2 mr-sm-2 mb-sm-0 form__input" id="sort">
        <option value="asc" selected>A to Z</option>
        <option value="desc">Z to A</option>
      </select>
      <select v-else v-model="sort" @change="sort" aria-describedby="sortResults"
               class="form-select mb-2 mr-sm-2 mb-sm-0 form__input" id="sort">
         <option value="neither">Select One</option>
         <option value="desc">Newest</option>
         <option value="asc">Oldest</option>
      </select>
    </div>
  </form>
</template>

<script>
  export default {
    name: "SortPage",
    props: {
      arrayToSort: Array,
      pKinds: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        sortMethod: 'neither',
      }
    },
    methods: {
      sort: function () {
        let sortedArray = this.arrayToSort;
        if (this.sortMethod != 'neither'){
          sortedArray =  _.orderBy(this.arrayToSort, [( element ) => { return element.lo || element.lodate || '' }], this.sortMethod);
          this.$emit('sortArray', sortedArray);
        }
      },
      sortKind: function () {
        let sortedArray = this.arrayToSort
        if (this.sortMethod != 'neither'){
          sortedArray = _.orderBy(this.arrayToSort, [( element ) => { return element.procName.toLowerCase() }], this.sortMethod)
          this.$emit('sortArray', sortedArray)
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .form__label {
    font-size: 0.85em;
    color: lighten(#000, 30%);
  }
  .form__input {
    font-size: 0.75em;
    color: lighten(#000, 30%);
  }
  .icon {
    color: lighten(#000, 50%);
  }
</style>